<template>
    <div class="all_ynjc">
        <div class="main_ynjc">
            <!--头部-->
            <header1></header1>
            <!--导航-->
            <navigation></navigation>
            <div class="position_ynjc">您所在的位置：<router-link  :to="{ path: '/'}">首&nbsp;页</router-link><span>&gt;&gt;</span>关于平台</div>
            <!--政策法规/下载专区-->
            <div class="erji_ynjc">
                <div class="infoBox_ynjc">
                    <div class="notices_main_ynjc">
                        <div class="detailInfo_ynjc">
                            <!--<div class="detailInfo_title_ynjc">{{newsInfo.newsTitle}}</div>-->
                            <div class="detailInfo_main_ynjc">
                                <div style="text-align: center;line-height: 50px; font-size: 24px; font-weight: bold;">云南省基层卫生信息网简介</div>
                                <div style="text-align: left;line-height: 40px; font-size: 16px;">
                                    <strong style="font-size: 18px;"><br>一、平台整体介绍</strong><br>
                                    <p style="text-indent: 2em;">云南省基层卫生信息网是各级卫生计生行政部门和基层医疗卫生机构用于统计分析我省基层医疗卫生机构服务能力基础资源，规范我省乡村医生的准入培训、考核、执业注册、岗位培训等多方服务平台。各级卫生计生行政部门通过本平台及时了解我省基层医疗卫生机构的房屋建筑情况、编制情况、床位情况、人员配备、设备配备、乡村医生准入培训及考核情况、乡村医生执业注册情况、在岗继续医学教育情况。为进一步加快推进我省基层医疗卫生服务能力建设提供参考依据。</p>
                                    <strong style="font-size: 18px;">二、系统简介</strong>
                                    <p style="text-indent: 2em;"><strong>（一）乡村医生准入培训和考核系统</strong></p>
                                    <p style="text-indent: 2em;">此系统是为村卫生室招聘人员、进行乡村医生入岗前培训和考核的系统。取得省级教育行政部门认可的中专及以上医学专业学历的人员，报名成功的准乡村医生使用自己的账号和密码登录系统，参加乡村医生入岗前网络课程学习，学习完毕后，参加在线考试。考试合格并由当地卫生计生行政部门考核合格，正式聘用为乡村医生。</p>
                                    <p style="text-indent: 2em;"><strong>（二）乡村医生执业注册信息管理系统</strong></p>
                                    <p style="text-indent: 2em;"> 此系统是县级卫生计生行政部门用于管理辖区内乡村医生执业注册、执业再注册、执业注销、暂停执业活动信息的系统。</p>
                                    <p style="text-indent: 2em;"><strong>（三）基层卫生人员培训报名管理系统</strong></p>
                                    <p style="text-indent: 2em;">此系统是省-市-县三级管理员用于发起乡村医生准入培训和乡村医生岗位培训、创建培训班，查询统计培训具体数据的系统；是乡-村两级管理员用于培训报名和成绩上传的系统。</p>
                                    <p style="text-indent: 2em;">培训管理：</p>
                                    <p style="text-indent: 2em;">（1）省-市-县三级管理员用于创建线下准入、岗位培训班，用于线下集中培训的考勤管理。<br>　　（2）乡-村两级管理员用于乡村医生准入培训和乡村医生岗位培训参培人员批量报名；审核“乡村医生准入培训和考核系统”医生个人报名。</p>
                                    <p style="text-indent: 2em;">成绩管理：</p>
                                    <p style="text-indent: 2em;">管理网络在线考试成绩，上传线下理论培训、实践技能培训考核成绩。</p>
                                    <p style="text-indent: 2em;"><strong>（四）乡村医生岗位培训和考核系统</strong></p>
                                    <p style="text-indent: 2em;"> 此系统是基层医疗卫生机构用于提升在岗乡村医生医疗业务技术知识培训和考核管理的系统。报名成功的在岗乡村医生使用自己的账号和密码登录系统，进行网上培训学习、考试的系统。</p>
                                    <p style="text-indent: 2em;"><strong>（五）基层医疗卫生机构档案管理系统</strong>
                                    <p style="text-indent: 2em;">  此系统是基层医疗卫生机构用于管理辖区机构信息和本单位人员信息、设备配备、房屋建筑情况、床位设置、资产、收入、主要业务工作信息的系统。</p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--版权-->
            <footer1></footer1>
        </div>
    </div>
</template>

<script>
    import  navigation from '../components/Navigation';
    import  header1 from '../components/Header1';
    import  footer1 from '../components/Footer1';
    export default {
        components: {
            header1,
            footer1,
            navigation
        },
        data () {
            return {

            }
        },
        mounted () {
            /*getNews({
                id: this.$route.query.id
            }).then((response) => {
                this.newsInfo = response.data.data.newsInfo;
                document.title="资讯详情-"+this.newsInfo.newsTitle
            })*/
        },
        computed: {},
        methods: {}
    }
</script>